import * as React from 'react';
import { TooltipDesktop } from '@cian/ui-kit/tooltip';
import { Paragraph1, InlineText2, InlineText3 } from '@cian/ui-kit/typography';
import classNames from 'classnames';
import * as styles from './styles.css';

export interface IBuilderStatusProps {
  labelText: string;
  tooltipTitle: string;
  tooltipText: string;
}

export function BuilderStatus(props: IBuilderStatusProps) {
  const { labelText, tooltipText, tooltipTitle } = props;

  return (
    <TooltipDesktop
      theme={'white'}
      title={
        <div className={styles['tooltip']}>
          <div className={styles['title']}>
            <Paragraph1 fontWeight={'bold'}>{tooltipTitle}</Paragraph1>
          </div>
          <InlineText2>{tooltipText}</InlineText2>
        </div>
      }
    >
      <div className={classNames(styles['container'], styles['builder-status'])}>
        <InlineText3 color={'white_100'}>{labelText}</InlineText3>
      </div>
    </TooltipDesktop>
  );
}
